<template>
  <BContainer fluid class="nav-bar-esenca">
    <div class="topnav bg-vue text-start ps-0">
      <nav class="navbar navbar-light navbar-expand-lg topnav-menu ps-0">
        <div class="collapse navbar-collapse" id="topnav-menu-content">
          <ul class="navbar-nav w-100 ps-2">
            <li
              class="nav-item dropdown"
              v-for="(item, index) in menuByLang()"
              :key="index"
            >
              <NuxtLink
                v-if="!hasItems(item)"
                :to="item.link"
                class="nav-link arrow-none side-nav-link-ref"
              >
                <i :class="`${item.icon} me-2`"></i>
                {{ item.label }}
              </NuxtLink>

              <a
                v-else
                class="nav-link dropdown-toggle arrow-none d-flex align-items-center"
                href="javascript:void(0);"
                :id="`topnav-components-${index}`"
                role="button"
                @click="onMenuClick($event, index)"
              >
                <i :class="`${item.icon} me-2`"></i>
                <span>{{ item.label }}</span>
                <div class="arrow-down ms-2"></div>
              </a>

              <div
                v-if="hasItems(item)"
                class="dropdown-menu"
                :class="{
                  show: openedMenu === index,
                  'dropdown-mega-menu-xl px-2': item.subItems.length > 30
                }"
                :id="`menu-item-${index}`"
                :aria-labelledby="`topnav-components-${index}`"
              >
                <template v-for="(subitem, subIndex) in item.subItems" :key="subIndex">
                  <NuxtLink
                    v-if="item.subItems.length <= 30 && !hasItems(subitem)"
                    class="col dropdown-item side-nav-link-ref"
                    :to="subitem.name ? subitem.name : subitem.link"
                    @click="closeAllMenus"
                  >
                    {{ subitem.label }}
                  </NuxtLink>

                  <div v-if="item.subItems.length > 30">
                    <div v-if="subIndex % 3 === 0" class="row">
                      <div class="col-lg-4">
                        <NuxtLink
                          class="dropdown-item side-nav-link-ref"
                          :to="subitem.link"
                          @click="closeAllMenus"
                        >
                          {{ item.subItems[subIndex].label }}
                        </NuxtLink>
                      </div>

                      <div class="col-lg-4" v-if="item.subItems[subIndex + 1]">
                        <NuxtLink
                          class="dropdown-item side-nav-link-ref"
                          :to="item.subItems[subIndex + 1].link"
                          @click="closeAllMenus"
                        >
                          {{ item.subItems[subIndex + 1].label }}
                        </NuxtLink>
                      </div>

                      <div class="col-lg-4" v-if="item.subItems[subIndex + 2]">
                        <NuxtLink
                          class="dropdown-item side-nav-link-ref"
                          :to="item.subItems[subIndex + 2].link"
                          @click="closeAllMenus"
                        >
                          {{ item.subItems[subIndex + 2].label }}
                        </NuxtLink>
                      </div>
                    </div>
                  </div>

                  <div
                    class="dropdown dropdown-submenu"
                    v-if="hasItems(subitem) && item.subItems.length <= 30"
                  >
                    <a
                      class="dropdown-item d-flex align-items-center justify-content-between"
                      href="javascript:void(0);"
                      @click.stop="toggleSubmenu(index, subIndex)"
                    >
                      <span>{{ subitem.label }}</span>
                      <div class="arrow-down ms-2"></div>
                    </a>

                    <div
                      class="dropdown-menu"
                      :class="{ show: isSubmenuOpen(index, subIndex) }"
                    >
                      <NuxtLink
                        v-for="(subSubitem, subSubIndex) in subitem.subItems"
                        :key="subSubIndex"
                        :to="subSubitem.link"
                        class="dropdown-item side-nav-link-ref"
                        @click="closeAllMenus"
                      >
                        {{ subSubitem.label }}
                      </NuxtLink>
                    </div>
                  </div>
                </template>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </BContainer>
</template>

<script setup>
import { computed, ref, onMounted, onBeforeUnmount } from 'vue'
import { BContainer } from 'bootstrap-vue-next'
import menuIList from '../utils/menu-top.js'

const openedMenu = ref(null)
const openedSubmenus = ref({})

const menuByLang = () => {
  return menuIList.data().menuItems
}

const hasItems = (item) => {
  return Array.isArray(item?.subItems) && item.subItems.length > 0
}

const closeAllMenus = () => {
  openedMenu.value = null
  openedSubmenus.value = {}
}

const onMenuClick = (event, index) => {
  event.preventDefault()

  const trigger = event.currentTarget
  if (!trigger) return

  openedSubmenus.value = {}

  if (openedMenu.value === index) {
    openedMenu.value = null
    return
  }

  openedMenu.value = index
}

const toggleSubmenu = (parentIndex, subIndex) => {
  const key = `${parentIndex}-${subIndex}`
  openedSubmenus.value[key] = !openedSubmenus.value[key]
}

const isSubmenuOpen = (parentIndex, subIndex) => {
  return !!openedSubmenus.value[`${parentIndex}-${subIndex}`]
}

const handleDocumentClick = (event) => {
  const navWrapper = document.querySelector('.nav-bar-esenca')
  if (!navWrapper) return

  if (!navWrapper.contains(event.target)) {
    closeAllMenus()
  }
}

onMounted(() => {
  document.addEventListener('click', handleDocumentClick)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleDocumentClick)
})
</script>

